import {
  PendantList,
  PendantObj
} from '@/base/module_config'

const left_sidebar = {
  namespaced: true,
  state: {
    PendantList,
    PendantObj,
    dialogVisible: false,
    active: 'module',
    module_tab_active: 'module',
    styleActive: 'basic',
    searchContent: ''
  },
  mutations: {
    set_dialog(state, dialogVisible) {
      state.dialogVisible = dialogVisible
    },
    set_active(state, active) {
      state.active = active
    },
    set_module_tab_active(state, v) {
      state.module_tab_active = v
    },
    set_style_active(state, active) {
      state.styleActive = active
    },
    set_search_content(state, v) {
      state.searchContent = v
    },
  },
  actions: {}
}


export default left_sidebar



// WEBPACK FOOTER //
// ./src/vuex/modules/left_sidebar.js